import { clamp } from 'lodash-es';

import { VIconButton } from '../VIconButton';
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from '../asset';
import { PAGE_BUTTON_STATE, style } from './style';

export type VPaginationProps = {
  currentPage: number;
  totalPage: number;
  pagePerOnce?: number;
  onChange: (page: number) => void;
};

const VPagination = ({
  currentPage,
  totalPage,
  pagePerOnce = 6,
  onChange,
}: VPaginationProps) => {
  const _totalPage = Math.max(1, totalPage);
  const _currentPage = clamp(currentPage, 1, _totalPage);
  const _pagePerOnce = clamp(pagePerOnce, 1, _totalPage);

  const startPage =
    Math.floor((_currentPage - 1) / _pagePerOnce) * _pagePerOnce + 1;
  const pages: number[] = [];
  Array.from({ length: _pagePerOnce }).forEach((_, idx) => {
    const toPushPage = startPage + idx;
    if (toPushPage > totalPage) return;

    pages.push(toPushPage);
  });

  const isPrevAvailable = _currentPage >= 2;
  const isNextAvailable = _currentPage <= _totalPage - 1;
  const isFirstAvailable = _currentPage !== 1;
  const isLastAvailable = _currentPage < _totalPage;

  const handleChange = (page: number) => {
    onChange(clamp(page, 1, _totalPage));
  };

  return (
    <div className={style.vPagination}>
      <div className={style.VPaginationControlContainer}>
        <VIconButton
          disabled={!isFirstAvailable}
          aria-label="first page"
          aria-disabled={!isFirstAvailable}
          onClick={() => handleChange(1)}
          Icon={KeyboardDoubleArrowLeft}
          variant="roundPrimary"
        />
        <VIconButton
          disabled={!isPrevAvailable}
          aria-label="previous page"
          aria-disabled={!isPrevAvailable}
          onClick={() => handleChange(_currentPage - 1)}
          Icon={KeyboardArrowLeft}
          variant="roundPrimary"
        />
      </div>

      {pages.map(num => {
        return (
          <div
            className={style.VPaginationPageButton(
              num === _currentPage
                ? PAGE_BUTTON_STATE.ACTIVE
                : PAGE_BUTTON_STATE.DEFAULT,
            )}
            key={num}
            onClick={() => handleChange(num)}
          >
            {num}
          </div>
        );
      })}

      <div className={style.VPaginationControlContainer}>
        <VIconButton
          aria-label="next page"
          aria-disabled={!isNextAvailable}
          disabled={!isNextAvailable}
          onClick={() => handleChange(_currentPage + 1)}
          Icon={KeyboardArrowRight}
          variant="roundPrimary"
        />
        <VIconButton
          disabled={!isLastAvailable}
          aria-label="last page"
          aria-disabled={!isLastAvailable}
          onClick={() => handleChange(_totalPage)}
          Icon={KeyboardDoubleArrowRight}
          variant="roundPrimary"
        />
      </div>
    </div>
  );
};

export default VPagination;
